import React, { useState, useEffect, useRef } from 'react';
import { Modal, Tabs, Tab, Table, Form, Button, Spinner, Alert, InputGroup, ListGroup, Badge, Pagination } from 'react-bootstrap';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { Copy, Edit, Save, X, Phone, Mail, MessageSquare, Trash2, Download, ArrowLeft } from 'react-feather';
import { FileEarmarkText, Pencil } from 'react-bootstrap-icons';
import { PAGOS_ALUMNOS_URL, ALUMNOSLIST_URL, CREATE_USER_AUTO_URL, OBSERVACIONES_URL, MOVIMIENTOS_URL, CREAR_REEMBOLSOS_URL,
  ACTUALIZAR_REEMBOLSOS_URL, ELIMINAR_REEMBOLSOS_URL, PERIODOS_ACCESO_URL, PERIODO_ACCESO_DETAIL_URL, LOGOUT_URL, CONFIGURATION_GLOBAL_URL
 } from '../apiConfig';
import { toast } from 'react-toastify';
import { FaWhatsapp } from 'react-icons/fa'; // Íconos de FontAwesome
import dayjs from 'dayjs';
import { el, se } from 'date-fns/locale';
import { ConfirmDialog } from './ConfirmDialog';
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSearch, FaListAlt, FaFileAlt, FaClipboardList } from "react-icons/fa";
import countriesData from './countries.json'; 
import Select from 'react-select';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import AttendanceModal from './AttendanceModal';

// Define PAYMENT_OPTIONS al principio del archivo (fuera del componente)
const PAYMENT_OPTIONS = [
  { value: "STRIPE", label: "Stripe" },
  { value: "PAYPAL", label: "PayPal" },
  { value: "BINANCE", label: "Binance" },
  { value: "MERCADOPAGO", label: "MercadoPago" },
  { value: "WISE", label: "Wise" },
  { value: "SANTANDER", label: "Santander" },
  { value: "ZELLE", label: "Zelle" },
  { value: "OTRO", label: "Otro" }
];


const CHECKBOX_FIELDS = [
  { name: "investigacion_nichos", label: "Investigación", icon: <FaSearch /> },
  { name: "oferta_servicio", label: "Oferta", icon: <FaListAlt /> },
  { name: "script_realizado", label: "Script", icon: <FaFileAlt /> },
  { name: "lista_armada", label: "Lista", icon: <FaClipboardList /> }
];

const AdminModal = ({ isOpen, onClose, alumno, isLoadingAlumno, mode = 'edit' }) => {
    const countries = countriesData.countries;
    const countryOptions = countriesData.countries.map((country) => ({
      label: country,
      value: country
    }));
    const [activeTab, setActiveTab] = useState('detalles');
    const [formData, setFormData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // Valor por defecto 10
    const [isEditing, setIsEditing] = useState(false);
    const [newPago, setNewPago] = useState({
      fecha: new Date().toISOString().split('T')[0],
      medio_pago: 'STRIPE',
      cantidad: '',
      observaciones: ''
    });
    const queryClient = useQueryClient();
    const whatsappRef = useRef(null);
    const emailRef = useRef(null);
    const telefonoRef = useRef(null);
    const encuestaRef = useRef(null);
    const [editingPagoId, setEditingPagoId] = useState(null);
    const [editingPagoData, setEditingPagoData] = useState(null);
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    const [deleteDialog, setDeleteDialog] = useState({
      open: false,
      alumnoId: null,
      alumnoName: ''
    });
    const [emailError, setEmailError] = useState(false);
    const [loading, setLoading] = useState(false);
    const userRole = localStorage.getItem('is_administrator') === 'true' ? 'admin' : 'supervision'; // Determina el rol del usuario

    const [showCredentialsModal, setShowCredentialsModal] = useState(false);
    const [generatedCredentials, setGeneratedCredentials] = useState(null);
    const [currentPageObservaciones, setCurrentPageObservaciones] = useState(1);
    const [newObservacion, setNewObservacion] = useState({
      contenido: '',
      visibilidad: userRole =='admin'? 'ADMIN' : 'SUPERVISION', // Por defecto ADMIN o SUPERVISION según el rol
    });
    const [editingObservacionId, setEditingObservacionId] = useState(null);
    const [editingObservacionData, setEditingObservacionData] = useState({});
    const [isUpdatingObservacion, setIsUpdatingObservacion] = useState(false);
    const [showAttendanceModal, setShowAttendanceModal] = useState(false);

     // Estados para movimientos
    const [movimientosData, setMovimientosData] = useState({ results: [], count: 0 });
    const [loadingMovimientos, setLoadingMovimientos] = useState(false);
    const [errorMovimientos, setErrorMovimientos] = useState(null);
    
    // Estados para edición de movimientos
    const [editingMovimientoId, setEditingMovimientoId] = useState(null);
    const [editingMovimientoData, setEditingMovimientoData] = useState({});
    const [isUpdatingMovimiento, setIsUpdatingMovimiento] = useState(false);
    
    // Estados para reembolsos
    const [showReembolsoModal, setShowReembolsoModal] = useState(false);
    const [selectedPago, setSelectedPago] = useState(null);
    const [newReembolso, setNewReembolso] = useState({
      fecha: new Date().toISOString().split('T')[0],
      medio_reembolso: 'STRIPE',
      medio_reembolso_personalizado: '',
      cantidad: '',
      motivo: '',
      comprobante: null
    });
    const [inicioAccesoGlobal, setInicioAccesoGlobal] = useState(null);

    const getNextMonday = (fromDate) => {
      const date = new Date(fromDate);
      date.setHours(0, 0, 0, 0); // Normalizamos la hora
      
      // Si ya es lunes, devolvemos la misma fecha
      if (date.getDay() === 1) return date;
      
      // Avanzamos hasta el próximo lunes
      const daysUntilMonday = (8 - date.getDay()) % 7;
      date.setDate(date.getDate() + daysUntilMonday);
      return date;
    };
    // Función para obtener la fecha de inicio de acceso desde la configuración global

    const getInicioAcceso = async () => {
      try {
        const { data } = await axios.get(CONFIGURATION_GLOBAL_URL, {
          headers: { Authorization: `Token ${localStorage.getItem("token")}` },
        });
        const fecha = data.inicio_acceso ? new Date(data.inicio_acceso).toISOString() : null;
        // console.log("Fecha de inicio de acceso obtenida:", fecha);
        return fecha
      } catch (error) {
        console.error("Error obteniendo inicio de acceso:", error);
        toast.error("No se pudo obtener la fecha de inicio de acceso.");
        return null;
      }
    };

    const calculateDates = async () => {
      const hoy = new Date();
      // const inicioGlobal = (await getInicioAcceso()) || hoy;
      // setInicioAccesoGlobal(inicioGlobal);
      // Inicio de acceso (próximo lunes)
      // console.log("Inicio de acceso global:", inicioGlobal);
      

      // const inicioAcceso =
      //   inicioGlobal instanceof Date && !isNaN(inicioGlobal)
      //     ? inicioGlobal
      //     : getNextMonday(hoy);
      const inicioAcceso = getNextMonday(hoy);
      // Expiración: 90 días después del inicio + ajuste al domingo
      const expiracion = new Date(inicioAcceso);
      // 3 meses menos 1 día
      expiracion.setMonth(expiracion.getMonth() + 3);
      expiracion.setDate(expiracion.getDate() - 1);
      // const domingoExpiracion = getNextMonday(expiracion);
      // domingoExpiracion.setDate(domingoExpiracion.getDate() - 1);
      
      // Próximo pago: 1 día antes de la expiración
      const proximoPago = new Date(hoy);
      proximoPago.setDate(proximoPago.getDate() + 28);
    
      return {
        inicioAcceso: inicioAcceso.toISOString().split('T')[0],
        expiracion: expiracion.toISOString().split('T')[0],
        proximoPago: proximoPago.toISOString().split('T')[0]
      };
    };

    const { inicioAcceso, expiracion, proximoPago } = calculateDates();

    // Cambia el estado inicial a un array vacío para manejar los periodos en edición
    const [periodosEditState, setPeriodosEditState] = useState([]);

// En tu componente principal
    const [currentPagePeriodos, setCurrentPagePeriodos] = useState(1);
    const defaultFormData = {
      nombre: '',
      apellido: '',
      whatsapp: '',
      email: '',
      telefono: '',
      encuesta: '',
      inicio_acceso: inicioAcceso,
      expiracion: expiracion,
      proximo_pago: proximoPago,
      call_previa_nils: false,
      activo: true,
      clientes_inicio: 0,
      ingresos_mensuales: 0,
      clientes_conseguidos: 0,
      nicho: 'NINGUNO',
      nivel: 'NINGUNO',
      username_importado: '',
      fecha_pausado: null,
      fecha_reactivacion: null,
      prosp_country: '',
      prosp_city: '',
      trimestre: '1',
      grupo: 'A',
    };

      const navigate = useNavigate();
      const handleLogout = async () => {
        localStorage.removeItem('token');
        localStorage.removeItem('selectedDate');
        localStorage.removeItem('isSupervisor');
        try {
            await axios.post(LOGOUT_URL, null, { headers: { Authorization: `Token ${localStorage.getItem('token')}` } });
        } catch (error) {
          if (error.response && error.response.status === 401) {
          }
          else {
            console.error('Error logging out:', error);
          }
        } finally {
            navigate('/');
        }
    };
    // 1. Inicializar formData
    useEffect(() => {
      if (alumno) {
        // console.log('Alumno cargado:', alumno);
        setFormData({
          ...alumno,
          inicio_acceso: alumno.inicio_acceso?.split('T')[0] || '',
          expiracion: alumno.expiracion?.split('T')[0] || '',
          proximo_pago: alumno.proximo_pago?.split('T')[0] || ''
        });
        setIsEditing(false);
      }
      else {
        // console.log(inicioAccesoGlobal)
        setIsEditing(true);
        setFormData(defaultFormData);
      }
    }, [alumno, inicioAccesoGlobal]);
  
    // 2. Función para obtener pagos
    const fetchPagos = async ({ queryKey }) => {
      const [, alumnoId, page] = queryKey;
      try {
        const response = await axios.get(MOVIMIENTOS_URL.replace('<int:alumno_id>', alumno.id), {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        });
      
      setMovimientosData({
        results: response.data,
        count: response.data.length
      });
      // console.log('Movimientos obtenidos:', response.data);
      }
      catch (error) {
        if (error.response && error.response.status === 401) {
          // Si la respuesta es 401, redirigir al login
          console.error('Unauthorized access - redirecting to login');
          toast.error('Sesión expirada. Por favor, inicia sesión de nuevo.');
          handleLogout();
        }
        else { 
          console.error('Error fetching alumnos:', error);
        toast.error(`Error al actualizar el alumno: ${error.request?.response || error.message}`);            }
      }
      finally {
        setLoadingMovimientos(false);
      }
    };
  
    // 3. Query para pagos
    const { 
      data: pagosData = { results: [], count: 0 },
      isLoading: loadingPagos,
      isError: errorPagos
    } = useQuery({
      queryKey: ['pagos', alumno?.id, currentPage],
      queryFn: fetchPagos,
      enabled: ((!!alumno?.id && activeTab === 'pagos') || isOpen && !!alumno?.id) && alumno !== null && userRole === 'admin',
      keepPreviousData: true
    });
  
    // 4. Mutación para crear nuevo pago
    const createPagoMutation = useMutation({
      onMutate: () => {
        setLoading(true);
      },
      mutationFn: (pagoData) => axios.post(PAGOS_ALUMNOS_URL, pagoData, {
        headers: { Authorization: `Token ${localStorage.getItem('token')}` }
      }),
      onSuccess: () => {
        queryClient.invalidateQueries(['pagos', alumno?.id]);
        setNewPago({
          fecha: new Date().toISOString().split('T')[0],
          medio_pago: 'STRIPE',
          cantidad: '',
          observaciones: ''
        });
      },
      onError: (error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Si la respuesta es 401, redirigir al login
          console.error('Unauthorized access - redirecting to login');
          toast.error('Sesión expirada. Por favor, inicia sesión de nuevo.');
          handleLogout();
        }
        else { 
          console.error('Error fetching alumnos:', error);
          toast.error(`Error al crear el pago: ${error.request?.response || error.message}`);
        }
    
       
      },
      onSettled: () => {
        setLoading(false);
      }
    
    });

    const cleanWhatsappNumber = (number) => {
      // Eliminar todos los caracteres que no sean dígitos o +
      let cleaned = number.replace(/[^\d+]/g, '');
      
      // Si empieza con +, asegurarse que solo haya números después
      if (cleaned.startsWith('+')) {
        cleaned = '+' + cleaned.substring(1).replace(/\D/g, '');
      } else {
        cleaned = cleaned.replace(/\D/g, '');
      }
      
      return cleaned;
    };
    
    // 5. Mutación para actualizar alumno

    const updateAlumnoMutation = useMutation({
      mutationFn: async (alumnoData) => {
      setLoading(true); // Activar loading
      const payload = { ...alumnoData };

      if (payload.whatsapp) {
        payload.whatsapp = cleanWhatsappNumber(payload.whatsapp);
      }
      if(payload.expiracion === '') {
      payload.expiracion = null; // Si expiración está vacía, establecer como null
      };
      if(payload.proximo_pago === '') {
        payload.proximo_pago = null; // Si próximo pago está vacío, establecer como null
      };
      const response = await axios.patch(`${ALUMNOSLIST_URL}${alumno.id}/`, payload, {
        headers: { Authorization: `Token ${localStorage.getItem('token')}` }
      });

      setLoading(false); // Desactivar loading
      return response;
      },
      onSuccess: () => {
      queryClient.invalidateQueries(['alumnos']);
      setIsEditing(false);
      },
      onError: (error) => {
      setLoading(false); // Desactivar loading en caso de error
      toast.error(`Error al actualizar el alumno: ${error.request?.response || error.message}`);
      }
    });
  
    // 6. Manejo de cambios
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    };
  
    const handlePagoChange = (e) => {
      const { name, value } = e.target;
      setNewPago(prev => ({ ...prev, [name]: value }));
    };
  
    // 7. Manejo de envíos
    const handleSubmit = (e) => {
      e.preventDefault();
      if (mode === 'edit')  {
        updateAlumnoMutation.mutate(formData);
      }
      else {
        createAlumnoMutation.mutate(formData);
      }
    };
    // const handleSubmit = (e) => {
    //   e.preventDefault();
    //   onSave(formData);
    // };
  
    const handleAddPago = (e) => {
      e.preventDefault();
      createPagoMutation.mutate({
        ...newPago,
        alumno: alumno.id,
        cantidad: parseFloat(newPago.cantidad)
      });
    };
  
    // 8. Funciones para copiar datos
    const copyToClipboard = (ref, message) => {
      if (ref.current) {
        navigator.clipboard.writeText(ref.current.value);
        toast.info(`${message} copiado al portapapeles`);
      }
    };
  
    // 9. Descarga de comprobantes
    const handleDownloadComprobante = async (url) => {
      try {
        const response = await axios.get(url, {
          responseType: 'blob',
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        });
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `comprobante_${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error descargando comprobante:', error);
        toast.error(`Error al actualizar el alumno: ${error.request?.response || error.message}`);
        alert('No se pudo descargar el comprobante');
      }
    };
    // 10. Mutación para actualizar pago
    const { 
      mutate: updatePago,  // <- Renombramos mutate a updatePago
      isLoading: isUpdatingPago 
    } = useMutation({
      mutationFn: ({ pagoId, pagoData }) => {
        setLoading(true); // Activar loading al iniciar
        return axios.patch(`${PAGOS_ALUMNOS_URL}${pagoId}/`, {
          ...pagoData,
          alumno: alumno.id
        }, {
          headers: { 
            Authorization: `Token ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['pagos', alumno?.id]);
        setEditingMovimientoId(null);
        setEditingPagoId(null);
        setEditingPagoData(null);
        toast.info('Pago actualizado correctamente');
      },
      onError: (error) => {
        console.error('Error al actualizar pago:', error.response?.data);
        toast.error(`Error al actualizar el alumno: ${error.request?.response || error.message}`);
      },
      onSettled: () => {
        setLoading(false); // Desactivar loading al finalizar
      }
    });
    
    // 11. Mutación para borrar pago
    const { 
      mutate: deletePago,  
      isLoading: isDeletingPago 
    } = useMutation({
      mutationFn: (editingPagoId) => {
        setLoading(true); // Activa loading al iniciar
        return axios.delete(`${PAGOS_ALUMNOS_URL}${editingPagoId}/?alumno_id=${alumno.id}`, {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['pagos', alumno?.id]);
        toast.info('Pago eliminado correctamente');
      },
      onError: (error) => {
        console.error('Error al eliminar pago:', error.response?.data);
        toast.error(`Error al actualizar el alumno: ${error.request?.response || error.message}`);
      },
      onSettled: () => {
        setLoading(false); // Desactiva loading al finalizar
      }
    });
    

    // 12. Manejo de edición de pago
    const handleEditPago = (pago) => {
        setEditingPagoId(pago.id);
        setEditingPagoData({
        fecha: pago.fecha,
        medio_pago: pago.medio_pago,
        cantidad: pago.cantidad,
        observaciones: pago.observaciones
        });
    };

    // 13. Manejo de cambios en edición de pago
    const handleEditingPagoChange = (e) => {
        const { name, value } = e.target;
        setEditingPagoData(prev => ({ ...prev, [name]: value }));
    };

    // 14. Cancelar edición de pago
    const handleCancelEditPago = () => {
        setEditingPagoId(null);
        setEditingPagoData(null);
    };

    
    // 15. Guardar cambios de pago (modificado)
    const handleSavePago = (pagoId) => {
        if (!alumno?.id) {
        alert('No se ha seleccionado un alumno válido');
        return;
        }
        // Usamos updatePago directamente
        updatePago({ 
        pagoId,
        pagoData: {
            ...editingMovimientoData,
            alumno: alumno.id
        }
        });
    };
    
    // 16. Borrar pago (modificado)
    const handleDeletePago = (pagoId) => {
        if (window.confirm('¿Estás seguro de querer eliminar este pago?')) {
        // Usamos deletePago directamente
        deletePago(pagoId);
        }
    };

    // 17. Creación de Alumno
    // Mutación para crear nuevo alumno
    const createAlumnoMutation = useMutation({
      mutationFn: (alumnoData) => {
        const payload = {...alumnoData};
        
        // Limpiar formato de WhatsApp si existe
        if (payload.whatsapp) {
          payload.whatsapp = cleanWhatsappNumber(payload.whatsapp);
        }
        
        return axios.post(ALUMNOSLIST_URL, payload, {
          headers: { 
            Authorization: `Token ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['alumnos']);
        // setIsEditing(false);

        // setModalOpen(false); // Cerrar el modal después de crear
        // Opcional: mostrar notificación de éxito
        toast.info('Alumno creado exitosamente');
        setFormData(defaultFormData);
      },
      onError: (error) => {
        // Manejar errores
        toast.error('Error al crear alumno: ' + error.message);
        toast.error(`Error al crear el alumno: ${error.request?.response || error.message}`);
      }
    });

    // 18. Eliminar alumno
    const deleteAlumnoMutation = useMutation({
      mutationFn: (alumnoId) => 
        axios.delete(`${ALUMNOSLIST_URL}${alumnoId}/`, {
          headers: { 
            Authorization: `Token ${localStorage.getItem('token')}`
          }
        }),
      onSuccess: () => {
        queryClient.invalidateQueries(['alumnos']);
        toast.success('Alumno eliminado correctamente');
        onClose()
      },
      onError: (error) => {
        // toast.error('Error al eliminar alumno: ' + error.message);
        toast.error(`Error al eliminar el alumno: ${error.request?.response || error.message}`);
      }
    });
    // Función para manejar la eliminación
    const handleDelete = (alumno) => {
      setDeleteDialog({
        open: true,
        alumnoId: alumno.id,
        alumnoName: alumno.nombre
      });
    };

   //  Mutación para crear el usuario MILKIFORMA (simplificada)
    const createUserMutation = useMutation({
      mutationFn: () => 
        axios.post(CREATE_USER_AUTO_URL, { 
          alumno: {
            nombre: alumno.nombre,
            apellido: alumno.apellido,
            email_importado: alumno.email_importado
          }
        }, {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        }),
      onSuccess: (data) => {
        setGeneratedCredentials(data.data);
        setShowCredentialsModal(true);
        // Si necesitas actualizar algún estado padre o invalidar queries:
        // onUserCreated?.(); // Callback opcional
        // queryClient.invalidateQueries(['alumnos', alumno.id]);
      },
      onError: (error) => {
        toast.error(`Error al generar credenciales: ${error.request?.response || error.message}`);

       setGeneratedCredentials(null);
  }
  
    });

    // Función para obtener observaciones
      
  const fetchObservaciones = async ({ queryKey }) => {
    const [, alumnoId, page] = queryKey;
    try {
      const response = await axios.get(
        `${OBSERVACIONES_URL.replace('<int:user_id>', alumnoId)}?page=${page}&page_size=${pageSize}`,
        {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        }
      );
      // console.log('Observaciones obtenidas:', response.data);
      return response.data;
    } catch (error) {
      toast.error(`Error al obtener observaciones: ${error.request?.response || error.message}`);
      // throw error;
    }
  };

  // Query para observaciones
  const { 
    data: observacionesData = { results: [], count: 0 },
    isLoading: loadingObservaciones,
    isError: errorObservaciones
  } = useQuery({
    queryKey: ['observaciones', alumno?.id, currentPageObservaciones],
    queryFn: fetchObservaciones,
    enabled: ((!!alumno?.id && activeTab === 'observaciones') || isOpen && !!alumno?.id) && alumno !== null,
    keepPreviousData: true
  });

  
    useEffect(() => {
      if (!!loadingPagos || !!isUpdatingPago || !!isDeletingPago || !!isLoadingAlumno || !!loadingObservaciones || 
        !!loadingMovimientos || !!isUpdatingObservacion ||!!isUpdatingMovimiento || !!isDeletingPago
            ) {
        setLoading(true);
        
        // console.log('Loading state:', {
        //   loadingPagos,
        //   isUpdatingPago, 
        //   isDeletingPago,
        //   isLoadingAlumno,
        //   loadingObservaciones,
        //   loadingMovimientos,
        //   isUpdatingObservacion,
        //   isUpdatingMovimiento,
        //   isDeletingPago
        // });
        }
      

      else {
        setLoading(false);
      }
    }, [loadingPagos, isUpdatingPago, isDeletingPago, isLoadingAlumno, loadingObservaciones, loadingMovimientos, isUpdatingObservacion,isUpdatingMovimiento,
      isDeletingPago ]);
    
  //  Handlers para cambios en formularios
  const handleObservacionChange = (e) => {
    const { name, value } = e.target;
    setEditingObservacionData(prev => ({ ...prev, [name]: value }));
    setNewObservacion(prev => ({ ...prev, [name]: value }));

  };

  const handleEditingObservacionChange = (e) => {
    const { name, value } = e.target;
    setEditingObservacionData(prev => ({ ...prev, [name]: value }));
  };

  
    // 3. Mutaciones para CRUD
  const createObservacionMutation = useMutation({
    mutationFn: (newObs) => axios.post(
      `${OBSERVACIONES_URL.replace('<int:user_id>', alumno.id)}`, 
      { ...newObs, alumno: alumno.id },
      { headers: { Authorization: `Token ${localStorage.getItem('token')}` } }
    ),
      onSuccess: () => {
        queryClient.invalidateQueries(['observaciones', alumno?.id, currentPageObservaciones]);
        setNewObservacion({ contenido: '', visibilidad: userRole == 'admin' ? 'ADMIN' : 'SUPERVISION' });
        toast.success('Observación creada con éxito');
      }
  });

  const updateObservacionMutation = useMutation({
    mutationFn: (updatedObs) => axios.put(
      `${OBSERVACIONES_URL.replace('<int:user_id>', alumno.id)}${editingObservacionId}/`, 
      {... updatedObs, alumno: alumno.id },
      { headers: { Authorization: `Token ${localStorage.getItem('token')}` } }
    ),
      onSuccess: () => {
        queryClient.invalidateQueries(['observaciones', alumno?.id, currentPageObservaciones]);
        setEditingObservacionId(null);
        toast.success('Observación actualizada con éxito');
      }
    }
  );

  const deleteObservacionMutation = useMutation({
    mutationFn: (obsId) => axios.delete(
      `${OBSERVACIONES_URL.replace('<int:user_id>', alumno.id)}${obsId}/`,
      { headers: { Authorization: `Token ${localStorage.getItem('token')}` } }
    ),
    
      onSuccess: () => {
        queryClient.invalidateQueries(['observaciones', alumno?.id, currentPageObservaciones]);
        toast.success('Observación eliminada con éxito');
        onClose();
      },
    onError: (error) => {
      toast.error(`Error al eliminar la observación: ${error.request?.response || error.message}`); 
    }
  }
  );

  //  Handlers para acciones
  const handleAddObservacion = (e) => {
    e.preventDefault();
    createObservacionMutation.mutate(newObservacion);
  };

  const handleEditObservacion = (observacion) => {
    setEditingObservacionId(observacion.id);
    setEditingObservacionData({
      contenido: observacion.contenido,
      visibilidad: observacion.visibilidad
    });
  };

  const handleSaveObservacion = () => {
    updateObservacionMutation.mutate(editingObservacionData);
  };

  const handleCancelEditObservacion = () => {
    setEditingObservacionId(null);
    setEditingObservacionData({});
  };

  const handleDeleteObservacion = (obsId) => {
    if (window.confirm('¿Estás seguro de eliminar esta observación?')) {
      deleteObservacionMutation.mutate(obsId);
    }
  };

  // 5. Función para determinar permisos
  const canEditObservacion = (observacion) => {
    const userId = parseInt(localStorage.getItem('user_id'), 10) || null;
    const isAdmin = localStorage.getItem('is_administrator') === 'true';
    return isAdmin || observacion.creado_por == userId;
  };

  
// Función para determinar el color del badge según la visibilidad
  const getBadgeColor = (visibilidad) => {
    switch(visibilidad) {
      case 'ADMIN': return 'danger';
      case 'SUPERVISION': return 'warning';
      case 'PUBLICA': return 'success';
      default: return 'secondary';
    }
  };

  // Crear reembolso
  const createReembolsoMutation = useMutation({
    mutationFn: (reembolsoData) => {
      const formData = new FormData();
      formData.append('pago', selectedPago.id);
      Object.keys(reembolsoData).forEach(key => {
        if (reembolsoData[key] !== null && reembolsoData[key] !== undefined) {
          formData.append(key, reembolsoData[key]);
        }
      });
      setLoading(true); // Activar loading al iniciar
      return axios.post(
        CREAR_REEMBOLSOS_URL.replace('<int:pago_id>', selectedPago.id),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Token ${localStorage.getItem('token')}`
          }
        }
      );
    },
        onSuccess: () => {
        queryClient.invalidateQueries(['pagos', alumno?.id]);
        setShowReembolsoModal(false);
        setNewReembolso({
        fecha: new Date().toISOString().split('T')[0],
        medio_reembolso: 'STRIPE',
        medio_reembolso_personalizado: '',
        cantidad: '',
        motivo: '',
        comprobante: null
      });
    },
        onError: (error) => {
      toast.error(`Error al crear el reembolso: ${error.request?.response || error.message}`);
    },
    onSettled: () => {
      setLoading(false); // Desactivar loading al finalizar
    }
  });

  const updateReembolsoMutation = useMutation({
    mutationFn: async ({ reembolsoId, reembolsoData }) => {
      return axios.put(
        `${ACTUALIZAR_REEMBOLSOS_URL.replace('<int:pk>', reembolsoId)}`, 
        reembolsoData,
        {
          headers: { 
            Authorization: `Token ${localStorage.getItem('token')}` 
          }
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['pagos', alumno?.id]);
      handleCancelEditMovimiento();
      toast.success('Reembolso actualizado correctamente');
    },
    onError: (error) => {
      console.error('Error actualizando reembolso:', error);
      toast.error(`Error al actualizar el reembolso: ${error.request?.response || error.message}`);
    }
  });

  const handleSaveReembolso = (reembolsoId) => {
    setIsUpdatingMovimiento(true);
    updateReembolsoMutation.mutate({
      reembolsoId,
      reembolsoData: editingMovimientoData
    });
  };
  
  // Mutación para eliminar un reembolso
  const deleteReembolsoMutation = useMutation({
    mutationFn: async (reembolsoId) => {
      setLoading(true); // Activar loading al iniciar
      return axios.delete(
        `${ELIMINAR_REEMBOLSOS_URL.replace('<int:pk>', reembolsoId)}`,
        {
          headers: { 
            Authorization: `Token ${localStorage.getItem('token')}` 
          }
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['pagos', alumno?.id]); // Actualizar la lista de pagos
      toast.success('Reembolso eliminado correctamente');
    },
    onError: (error) => {
      console.error('Error eliminando reembolso:', error);
      toast.error(`Error al eliminar el reembolso: ${error.request?.response || error.message}`);
    },
    onSettled: () => {
      setLoading(false); // Desactivar loading al finalizar
    }
  });

  // Función para manejar la eliminación de un reembolso
  const handleDeleteReembolso = (reembolsoId) => {
    deleteReembolsoMutation.mutate(reembolsoId);
  };
  
  // Actualizar handleSaveMovimiento y handleDeleteMovimiento
  const handleSaveMovimiento = (id, tipo) => {
    console.log(tipo)
    if (tipo === 'pago') {
      setEditingPagoId(id);
      handleSavePago(id);
    } else if (tipo === 'reembolso') {
      handleSaveReembolso(id);
    }
  };
  
  const handleDeleteMovimiento = (id, tipo) => {
    if (tipo === 'pago') {
      handleDeletePago(id);
    } else if (tipo === 'reembolso') {
      handleDeleteReembolso(id);
    }
  };

  // Manejador de cambios para edición de movimientos
  const handleEditingMovimientoChange = (e) => {
    const { name, value } = e.target;
    setEditingMovimientoData({
      ...editingMovimientoData,
      [name]: value
    });
  };

  // Iniciar edición de un movimiento
  const handleEditMovimiento = (movimiento) => {
    setEditingMovimientoId(movimiento.id);
    setEditingMovimientoData({
      ...movimiento,
      tipo_movimiento: movimiento.tipo_movimiento
    });
  };

  // Cancelar edición
  const handleCancelEditMovimiento = () => {
    setEditingMovimientoId(null);
    setEditingMovimientoData({});
  };


  // Abrir modal para agregar reembolso
  const handleAddReembolso = (pago) => {
    setSelectedPago(pago);
    setShowReembolsoModal(true);
  };

  // Manejador de cambios para formulario de reembolso
  const handleReembolsoChange = (e) => {
    const { name, value } = e.target;
    setNewReembolso({
      ...newReembolso,
      [name]: value
    });
  };


  // Enviar formulario de reembolso
  const handleAddReembolsoSubmit = (e) => {
    e.preventDefault();
    createReembolsoMutation.mutate(newReembolso);
  };
  // Función para obtener los estilos basados en el tema
  const getSelectStyles = (theme) => ({
    placeholder: (provided) => ({
      ...provided,
      color: theme === 'light' ? '#6c757d' : '#adb5bd',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: theme === 'light' ? '#495057' : '#ced4da',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === 'light' ? '#495057' : '#f8f9fa',
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: '38px',
      backgroundColor: theme === 'light' ? '#fff' : '#343a40',
      borderColor: state.isFocused 
        ? theme === 'light' ? '#80bdff' : '#495057' 
        : theme === 'light' ? '#ced4da' : '#495057',
      boxShadow: state.isFocused 
        ? theme === 'light' 
          ? '0 0 0 0.2rem rgba(0,123,255,.25)' 
          : '0 0 0 0.2rem rgba(130,138,145,.5)'
        : 'none',
      '&:hover': {
        borderColor: state.isFocused 
          ? theme === 'light' ? '#80bdff' : '#495057' 
          : theme === 'light' ? '#ced4da' : '#6c757d',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme === 'light' ? '#fff' : '#343a40',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme === 'light' ? '#007bff' : '#495057'
        : state.isFocused
        ? theme === 'light' ? '#e9ecef' : '#212529'
        : theme === 'light' ? '#fff' : '#343a40',
      color: state.isSelected
        ? '#fff'
        : theme === 'light' ? '#495057' : '#f8f9fa',
    }),
  });

  const selectStyles = getSelectStyles(theme);
// FETCH: Obtener lista de periodos de acceso


const fetchPeriodosAcceso = async ({ queryKey }) => {
  const [,alumnoId, page] = queryKey;
  try {
    const response = await axios.get(
      `${PERIODOS_ACCESO_URL}?alumno_id=${alumnoId}&page=${page}&page_size=${pageSize}`,
      {
        headers: { Authorization: `Token ${localStorage.getItem('token')}` }
      }
    );
    // console.log('Periodos de acceso obtenidos:', response.data);
    return response.data;
  } catch (error) {
    toast.error(`Error al obtener periodos de acceso: ${error.request?.response || error.message}`);
    throw error;
  }
};

// CREATE: Crear nuevo periodo de acceso
const createPeriodoAcceso = async (newPeriodo) => {
  setLoading(true); // Activar loading al iniciar
  try {
    const response = await axios.post(
      PERIODOS_ACCESO_URL,
      {... newPeriodo, alumno: alumno.id },
      {
        headers: { 
          Authorization: `Token ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    toast.success("Periodo de acceso creado con éxito");
    return response.data;
  } catch (error) {
    toast.error(`Error al crear periodo de acceso: ${error.request?.response || error.message}`);
    throw error;
  }finally {
    setLoading(false); // Desactivar loading al finalizar
  }
};

// UPDATE: Actualizar periodo de acceso existente
const updatePeriodoAcceso = async ({ id, updatedData }) => {
  setLoading(true); // Activar loading al iniciar
  try {
    const response = await axios.patch(
      PERIODO_ACCESO_DETAIL_URL.replace('<int:pk>', id),
      updatedData,
      {
        headers: { 
          Authorization: `Token ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    toast.success("Periodo de acceso actualizado con éxito");
    return response.data;
  } catch (error) {
    toast.error(`Error al actualizar periodo de acceso: ${error.request?.response || error.message}`);
    throw error;
  }
  finally {
    setLoading(false); // Desactivar loading al finalizar
  }
};

// DELETE: Eliminar periodo de acceso
const deletePeriodoAcceso = async (id) => {
  setLoading(true); // Activar loading al iniciar
  try {
    await axios.delete(
      PERIODO_ACCESO_DETAIL_URL.replace('<int:pk>', id),
      {
        headers: { Authorization: `Token ${localStorage.getItem('token')}` }
      }
    );
    toast.success("Periodo de acceso eliminado con éxito");
    return id;
  } catch (error) {
    toast.error(`Error al eliminar periodo de acceso: ${error.request?.response || error.message}`);
    throw error;
  }
  finally {
    setLoading(false); // Desactivar loading al finalizar
  }
};

// Query para obtener periodos de acceso
const { 
  data: periodosData = { results: [], count: 0 },
  isLoading: loadingPeriodos,
  isError: errorPeriodos
} = useQuery({
  queryKey: ['periodosAcceso', alumno?.id, currentPagePeriodos],
  queryFn: fetchPeriodosAcceso,
  keepPreviousData: true,
  enabled: ((activeTab === 'periodos') || isOpen )&& !!alumno?.id && alumno !== null,
});
// console.log('Periodos de acceso obtenidos:', periodosData);
// Mutaciones para CRUD

// Crear periodo
const { mutate: createPeriodo } = useMutation({
  mutationFn: createPeriodoAcceso,
  onSuccess: () => {
    queryClient.invalidateQueries(['periodosAcceso']);
  }
});

// Actualizar periodo
const { mutate: updatePeriodo } = useMutation( {
  mutationFn: updatePeriodoAcceso,
  onSuccess: () => {
    queryClient.invalidateQueries(['periodosAcceso']);
  }
});

// Eliminar periodo
const { mutate: deletePeriodo } = useMutation({
  mutationFn: deletePeriodoAcceso,
  onSuccess: () => {
    queryClient.invalidateQueries(['periodosAcceso']);
  }
});

// Usar createPeriodo, updatePeriodo y deletePeriodo directamente donde se necesiten



    return (
      <>
        <Modal 
          show={isOpen} 
          onHide={onClose}
          size="xl"
          centered
          backdrop="static"
          // dialogClassName="large-modal-width"
          className={`${theme === 'dark' ? 'modal-dark' : 'modal-light'} custom-modal`} // Clase personalizada
        >
          <Modal.Header 
            closeButton
            className={` large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} // Añadir clase
            >
            <Modal.Title>
              {(() => {
                if (loading) return 'Cargando...';
                if (mode === 'create') return 'Creando Nuevo Alumno';
                return (alumno?.nombre || '') + (' ' + alumno?.apellido || '');
              })()}
              {isEditing && alumno? <span className="text-muted ms-2">(Editando)</span> : ''}
              {updateAlumnoMutation.isLoading && (
                <Spinner animation="border" size="sm" className="ms-2" />
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={`large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark  '}`}>
            {updateAlumnoMutation.isError && (
              <Alert variant="danger" className="mb-3">
                Error al guardar los cambios
              </Alert>
            )}
    
           <Tabs activeKey={activeTab} 
              onSelect={(k) => setActiveTab(k)}
              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            >
                  {/* Pestaña Detalles */}
                  <Tab eventKey="detalles" title="Detalles del Alumno">
                    <Form id="editForm" onSubmit={handleSubmit} className="row mt-3 ">
                  <div className="col-md-6">

                    {/* Grupo de datos personales */}
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>

                        <Form.Label
                          className='w-50 p-0 m-0 align-self-center'>
                           Nombre:</Form.Label>
                        <Form.Control
                          disabled={userRole !== 'admin'}
                          className={`w-50 px-2 py-0 m-0' ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          name="nombre"
                          value={formData.nombre || ''}
                          onChange={handleChange}
                          readOnly={!isEditing}
                          plaintext={!isEditing}
                          required={true}
                        />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>

                        <Form.Label
                          className='w-50 p-0 m-0 align-self-center'>
                           Apellido:
                        </Form.Label>
                        <Form.Control
                          disabled={userRole !== 'admin'}
                          className={`w-50 px-2 py-0 m-0' ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          name="apellido"
                          value={formData.apellido || ''}
                          onChange={handleChange}
                          readOnly={!isEditing}
                          plaintext={!isEditing}
                          required={true}
                        />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3">

                      </Form.Group>
                      <Form.Group className="mb-3">
                    <div className='d-flex flex-row'
                    
                    style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}>
                      <Form.Label className='w-25 p-0 m-0 align-self-center'>
                        Email:
                      </Form.Label>
                      <Form.Control
                        className={`w-50 px-2 py-0 m-0' ${emailError ? 'is-invalid' : ''} ${theme === "light" ? "" : "input-theme-black"}`}
                        data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                        type="email"
                        name="email_importado"
                        value={formData.email_importado || ''}
                        onChange={(e) => {
                          const { value } = e.target;
                          setFormData(prev => ({ ...prev, email_importado: value }));
                          setEmailError(false); // Reset error al escribir
                        }}
                        onBlur={(e) => {
                          const email = e.target.value;
                          if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                            setEmailError(true);
                            toast.error('Correo electrónico inválido');
                          }
                        }}
                        readOnly={!isEditing}
                        plaintext={!isEditing}
                        required={isEditing}
                        ref={emailRef}
                        disabled={!isEditing || userRole !== 'admin'}
                      />
                      <Button 
                          className='admin-icon rounded mx-2 my-0'
                          variant="outline-secondary" 
                          onClick={() => copyToClipboard(emailRef, 'Email')}
                        >
                          <Copy size={16} />
                        </Button>
                        <Button 
                          className='admin-icon rounded mx-2 my-0'
                          variant="outline-primary"
                          href={`mailto:${formData.email_importado}`}
                          target="_blank"
                        >
                          <Mail size={16} />
                        </Button>
                      </div>
                      {emailError && (
                        <div className="invalid-feedback d-block">
                          Por favor ingresa un correo válido (ej: usuario@dominio.com)
                        </div>
                      )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                        <Form.Label
                          className='w-50 p-0 m-0 align-self-center'>
                            País:</Form.Label>
                        <Form.Control
                          disabled={userRole !== 'admin'}
                          className={`w-50 px-2 py-0 m-0' ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          name="pais"
                          value={formData.pais || ''}
                          onChange={handleChange}
                          readOnly={!isEditing}
                          plaintext={!isEditing}
                          required={true}
                        />
                        </div>
                      </Form.Group>
                      <Form.Group 
                        style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}
                        className="mb-3">
                        <Form.Label className='p-0 m-0'>
                          WhatsApp</Form.Label>
                        <InputGroup className='d-flex flex-row justify-content-end'>
                          <Form.Control
                            disabled={userRole !== 'admin'}
                            plaintext={!isEditing}
                            readOnly={!isEditing}
                            name="whatsapp"
                            value={formData.whatsapp || ''}
                            onChange={handleChange}
                            ref={whatsappRef}
                            className={`w-50 px-2 py-0 mx-2 rounded ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          />
                          <div
                          
                          >
                            <Button
                              className='admin-icon rounded mx-2 my-0'
        
                              variant="outline-secondary" 
                              onClick={() => copyToClipboard(whatsappRef, 'WhatsApp')}
                            >
                              <Copy size={'1rem'} />
                            </Button>
                            <Button 
                              className='admin-icon rounded mx-2 my-0'
                              variant="outline-success" 
                              href={`https://web.whatsapp.com/send/?phone=${formData.whatsapp?.replace(/\D/g, '')}`}
                              target="_blank"
                            >
                              <FaWhatsapp 
                              className=''
                              size={'1rem'} />
                            </Button>
                          </div>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group 
                        style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}
                        className="mb-3">
                        <Form.Label>Teléfono Alternativo</Form.Label>
                        <InputGroup className='d-flex flex-row justify-content-end'>
                          <Form.Control
                            disabled={userRole !== 'admin'}
                            plaintext={!isEditing}
                            readOnly={!isEditing}
                            name="otro_telefono"
                            value={formData.otro_telefono || ''}
                            onChange={handleChange}
                            ref={telefonoRef}
                            className={`w-50 px-2 py-0 mx-2 rounded ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          />
                          <div>
                            <Button 
                              variant="outline-secondary" 
                              className='admin-icon rounded mx-2 my-0'
        
                              onClick={() => copyToClipboard(telefonoRef, 'Teléfono')}
                            >
                              <Copy size={16} />
                            </Button>
                            <Button 
                              className='admin-icon rounded mx-2 my-0'
        
                                variant="outline-primary" 
                                href={`tel:${formData.otro_telefono}`}
                            >
                              <Phone size={16} />
                            </Button>
                          </div>
                        </InputGroup>
                      </Form.Group>

                    </div>

                    <div className="col-md-6">
                    <Form.Group className="my-3">
                        <div className='d-flex flex-row'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'> 
                              Fecha Inicio Acceso: </Form.Label>
                          <Form.Control
                            disabled={userRole !== 'admin'}
                            type={isEditing ? 'date' : 'text'}
                            name="inicio_acceso" 
                            className={`w-50 px-2 py-0 mx-2 rounded ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            readOnly={!isEditing}
                            plaintext={!isEditing}                          
                            onChange={handleChange}
                            value={
                              isEditing 
                                ? dayjs(formData.inicio_acceso).format('YYYY-MM-DD')
                                : dayjs(formData.inicio_acceso).format('DD/MM/YYYY')
                            }                          />
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                      <div className='d-flex flex-row'>
                        <Form.Label
                            className='w-50 p-0 m-0 align-self-center'> 
                              Fecha Expiración:
                        </Form.Label>
                        <Form.Control
                          disabled={userRole !== 'admin'}
                          className={`w-50 px-2 py-0 mx-2 rounded ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          type={isEditing ? 'date' : 'text'}
                          name="expiracion"
                          value={
                            isEditing 
                              ? dayjs(formData.expiracion).format('YYYY-MM-DD')
                              : (!!formData.expiracion ? dayjs(formData.expiracion).format('DD/MM/YYYY') : 'N/A')
                          }                          
                          onChange={handleChange}
                          readOnly={!isEditing}
                          plaintext={!isEditing}
                        />
                      </div>
                      </Form.Group>
                      
                      <Form.Group className="mb-3"> 
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'>
                              Días Restantes:
                          </Form.Label>
                            <Form.Control
                              className={`w-50 px-2 py-0 mx-2  ${theme === "light" ? "" : "bg-dark text-white"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              plaintext
                              readOnly
                              value={
                                formData.expiracion && formData.inicio_acceso && formData.pausado === false
                                  ? (new Date(formData.inicio_acceso) > new Date() ? Math.max(
                                      0,
                                      Math.ceil(
                                        (new Date(formData.expiracion) - new Date(formData.inicio_acceso)) / (1000 * 60 * 60 * 24)
                                      )
                                    ) : 
                                  Math.max(
                                      0,
                                      Math.ceil(
                                        (new Date(formData.expiracion) - new Date()) / (1000 * 60 * 60 * 24)
                                      )
                                    ))
                                  : !!formData.expiracion && !!formData.fecha_pausado && formData.pausado === true ? Math.max(
                                    0,
                                    Math.ceil(
                                      (new Date(formData.expiracion) - new Date(formData.fecha_pausado)) / (1000 * 60 * 60 * 24)
                                    )
                                  ) : 'N/A'
                              }
                            />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3"
                        style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}>
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'>
                              Próximo Pago:</Form.Label>
                            <Button
                              variant="outline-danger"
                              style={{ width: '3rem', 
                                height: '2rem', 
                                minWidth: '2rem', minHeight: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', margin: '0'   }}
                              className="me-2 p-0"
                              disabled={!isEditing || userRole !== 'admin'}
                              onClick={() => setFormData(prev => ({ ...prev, proximo_pago: '' }))}
                              title="Borrar fecha de próximo pago"

                            >
                              <X size={14} 
                              className='p-0 m-0'/>
                            </Button>
                          <Form.Control
                            disabled={userRole !== 'admin'}
                            className={`w-50 px-2 py-0 mx-2  ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            type={isEditing ? 'date' : 'text'}
                            name="proximo_pago"
                            value={
                              isEditing 
                                ? dayjs(formData.proximo_pago).format('YYYY-MM-DD')
                                : (formData.proximo_pago ? dayjs(formData.proximo_pago).format('DD/MM/YYYY') : 'N/A')
                            }                                                     
                            onChange={handleChange}
                            readOnly={!isEditing}
                            plaintext={!isEditing}
                            style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center '
                            style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}>
                            Total Pagado:
                            </Form.Label>
                          <Form.Control
                            className={`w-50  p-0 m-0  ${theme === "light" ? "" : "input-theme-black"}`}
                            plaintext
                            readOnly
                            style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}
                            value={`${parseFloat(formData.total_pagado || 0).toFixed(2)}$`}
                          />
                        </div>
                      </Form.Group>
                      {!!alumno?.pausado && (
                        <Form.Group className="mb-3">
                          <div className='d-flex flex-row justify-content-between'>
                            <Form.Label
                              className='w-50 p-0 m-0 align-self-center'>
                                Fecha pausado:</Form.Label>
                            <Form.Control
                              disabled={true}
                              className={`w-50 px-2 py-0 mx-2  ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              type={'text'}
                              name="fecha_pausado"
                              value={(formData.fecha_pausado ? dayjs(formData.fecha_pausado).format('DD/MM/YYYY') : 'N/A')}                                                                                
                              // onChange={handleChange}
                              readOnly={true}
                              plaintext={true}
                            />
                          </div>
                        </Form.Group>
                        )
                      }
                      <Form.Group className="mb-3">
                        <Form.Check 
                          
                          type="checkbox"
                          label="Alumno pausado"
                          name='pausado'
                          checked={!!formData.pausado}
                          onChange={handleChange}
                          disabled={!isEditing || userRole !== 'admin'}
                          style={{ cursor: isEditing && userRole === 'admin' ? 'pointer' : '' }}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Check 
                          type="checkbox"
                          label="Call con Nils realizada"
                          name="call_previa_nils"
                          checked={!!formData.call_previa_nils}
                          onChange={handleChange}
                          disabled={!isEditing || userRole !== 'admin'}
                          style={{ cursor: isEditing && userRole === 'admin' ? 'pointer' : '' }}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Check 
                          type="checkbox"
                          label="Activo"
                          name="activo"
                          disabled={!isEditing || userRole !== 'admin'}
                          checked={!!formData.activo}
                          onChange={handleChange}
                          style={{ cursor: isEditing && userRole === 'admin' ? 'pointer' : '' }}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                        />
                      </Form.Group>
                    </div>
                  </Form>
                </Tab>

                {/* Tab Académico */}
                <Tab eventKey="academico" 
                      title="Académico"
                      >
                  <Form className="row mt-3">
                    <div className="col-md-6">

                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                        <Form.Label
                          className='w-50 p-0 m-0 align-self-center'>Clientes iniciales:</Form.Label>
                        <Form.Control
                          className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          type="number"
                          name="clientes_inicio"
                          value={formData.clientes_inicio || 0}
                          onChange={handleChange}
                          readOnly={!isEditing}
                          plaintext={!isEditing}
                          disabled={userRole !== 'admin'}
                        />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'>Ingresos Mensuales:</Form.Label>
                          <Form.Control
                            className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            type={!isEditing ? "text" : "number"}
                            // step="0"
                            name="ingresos_mensuales"
                            value={`${(formData.ingresos_mensuales || 0)} $`}
                            onChange={handleChange}
                            readOnly={!isEditing}
                            plaintext={!isEditing}
                            disabled={userRole !== 'admin'}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'>Clientes conseguidos:</Form.Label>
                          <Form.Control
                            className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            type="number"
                            name="clientes_conseguidos"
                            value={formData.clientes_conseguidos || 0}
                            onChange={handleChange}
                            readOnly={!isEditing}
                            plaintext={!isEditing}
                          />
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label
                            className='w-50 p-0 m-0 align-self-center'>Nicho al iniciar:</Form.Label>
                          <Form.Control
                            disabled={userRole !== 'admin'}
                            className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            name="nicho"
                            value={formData.nicho || ''}
                            onChange={handleChange}
                            readOnly={!isEditing}
                            plaintext={!isEditing}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3 ">
                      <div className='d-flex flex-row justify-content-between align-items-center'> 
                        <Form.Label>Encuesta</Form.Label>
                          <InputGroup >
                            {formData.encuesta && !isEditing? (
                              <Button 
                                readOnly={userRole !== 'admin'}
                                variant="link" 
                                href={formData.encuesta} 
                                target="_blank"
                                className="p-0 m-auto align-self-center"
                                ref={encuestaRef}
                              >
                                Ver encuesta
                              </Button>
                            ) : (
                              <Form.Control
                                disabled={userRole !== 'admin'}
                                plaintext={!isEditing}
                                readOnly={!isEditing}
                                name="encuesta"
                                value={formData.encuesta || ''}
                                onChange={e => {
                                  const { value } = e.target;
                                  // Validar si es una URL válida solo al cambiar el valor
                                  handleChange(e);
                                }}
                                onBlur={e => {
                                  const { value } = e.target;
                                  const urlPattern = /^(https:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
                                  if (value && !urlPattern.test(value)) {
                                  toast.error('Por favor ingresa una URL válida');
                                  }
                                }}
                                ref={encuestaRef}
                                className={`w-50 px-2 py-0 m-2 ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              />
                            )}
                          </InputGroup>
                        </div>
                      </Form.Group>

                      {!alumno?.username_importado ? (
                        generatedCredentials ? (
                          // Estado temporal después de generar credenciales
                            <div className="mt-3 p-3 bg-light rounded">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                              <p className="mb-1">Credenciales para la Milkiforma:</p>
                              <div className="text-muted small">
                                <span className="d-block">Usuario: {generatedCredentials.username}</span>
                                <span className="d-block">Contraseña: {generatedCredentials.password}</span>
                              </div>
                              </div>
                              <button 
                              className="btn btn-outline-secondary btn-sm"
                              type='button'
                              onClick={async () => {
                                try {
                                  const text = `Estas son tus credenciales para la Milkiforma\nUsuario: ${generatedCredentials.username}\nContraseña: ${generatedCredentials.password}`;
                                  await navigator.clipboard.writeText(text);
                                  toast.success('Credenciales copiadas al portapeles', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                  });
                                } catch (err) {
                                  toast.error('Error al copiar las credenciales', {
                                    position: "top-right",
                                    autoClose: 3000,
                                  });
                                  console.error('Error al copiar:', err);
                                }
                              }}
                              >
                              Copiar
                              </button>
                            </div>
                            </div>
                          ) : (
                          // Botón para generar credenciales
                          <button 
                            type="button"
                            className="btn btn-primary mt-3"
                            onClick={(e) => {
                              e.preventDefault(); // Previene el comportamiento por defecto
                              createUserMutation.mutate();
                            }}
                            disabled={createUserMutation.isLoading}
                          >
                            {createUserMutation.isLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Generar Credenciales
                          </button>
                        )
                      ) : (
                        // Campo de usuario existente
                        <Form.Group className="mb-3">
                          <div className='d-flex flex-row justify-content-between'>
                            <Form.Label className='w-50 p-0 m-0 align-self-center'>
                              Usuario Milkiforma
                            </Form.Label>
                            <Form.Control
                              className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : ""}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              plaintext={!isEditing}
                              readOnly={!isEditing}
                              name="username_importado"
                              value={formData.username_importado || ''}
                              onChange={handleChange}
                            />
                          </div>
                        </Form.Group>
                      )}
                    </div>

                    <div className="col-md-6">

                    <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                          <Form.Label 
                            className='w-50 p-0 m-0 align-self-center'>SSM</Form.Label>
                          <Form.Control
                            className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            plaintext={!isEditing}
                            readOnly={!isEditing}
                            name="ssm"
                            value={formData.ssm || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-3 d-flex flex-wrap align-items-center gap-2 w-100">
                          {CHECKBOX_FIELDS.map((field) => (
                            <Form.Check
                              key={field.name}
                              type="checkbox"
                              id={`compact-${field.name}`}
                              inline
                              name={field.name}
                              label={
                                <span className="d-flex align-items-center gap-1">
                                  {field.icon}
                                  <span>{field.label}</span>
                                </span>
                              }
                              checked={!!formData[field.name]}
                              onChange={handleChange}
                              disabled={!isEditing}
                              className="pe-3 m-0"
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                          ))}
                        </Form.Group>
                      <div>
                        
                        <Form.Group className="mb-3">
                          <div className='d-flex flex-row justify-content-between'>
                            <Form.Label className='w-50 p-0 m-0 align-self-center'>
                              País de Prospección
                            </Form.Label>
                            {isEditing ? (
                              <Form.Select
                                className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                                name="prosp_country"
                                value={formData.prosp_country || ''}
                                onChange={handleChange}
                              >
                                <option value="">Seleccione un país</option>
                                {countryOptions.map(option => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </Form.Select>
                            ) : (
                              <Form.Control
                                plaintext
                                readOnly
                                className='w-50 p-0 m-0'
                                value={
                                  countryOptions.find(o => o.value === formData.prosp_country)?.label || 
                                  "Ningún país seleccionado"
                                }
                              />
                            )}
                          </div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <div className='d-flex flex-row justify-content-between'>
                            <Form.Label className='w-50 p-0 m-0 align-self-center'>
                              Ciudad de Prospección
                            </Form.Label>
                            <Form.Control
                              className={`w-50 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              plaintext={!isEditing}
                              readOnly={!isEditing}
                              name="prosp_city"
                              value={formData.prosp_city || ''}
                              onChange={handleChange}
                              placeholder="Ej: Buenos Aires"
                            />
                          </div>
                        </Form.Group>
                      </div>
                      <Form.Group className="mb-3">
                        <div className='d-flex flex-row justify-content-between'>
                        <Form.Label
                          className='w-25 p-0 m-0 align-self-center'>Trimestre:</Form.Label>
                        <Form.Select 
                          className={`w-25 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          style={{ cursor: isEditing ? 'pointer' : '' }}
                          name="trimestre"
                          value={formData.trimestre}
                          onChange={handleChange}
                          disabled={!isEditing}
                          plaintext={!isEditing}
                          as={isEditing ? 'select' : 'div'}
                        >
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </Form.Select>
                        <Form.Label
                          className='w-25 p-0 ms-4 me-0 align-self-center'>Grupo:</Form.Label>
                        <Form.Select 
                          className={`w-25 px-2 py-0 m-0 ${theme === "light" ? "" : "input-theme-black"}`}
                          data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          style={{ cursor: isEditing ? 'pointer' : '' }}
                          name="grupo"
                          value={formData.grupo}
                          onChange={handleChange}
                          disabled={!isEditing}
                          plaintext={!isEditing}
                          as={isEditing ? 'select' : 'div'}
                        >
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="D">D</option>
                        </Form.Select>
                        <Button
                          variant="outline-primary"
                          className="mx-2"
                          onClick={() => setShowAttendanceModal(true)}
                        >
                          Ver Asistencias
                        </Button>
                        <AttendanceModal
                          show={showAttendanceModal}
                          handleClose={() => setShowAttendanceModal(false)}
                          student={{ 
                            ...formData, 
                            id: formData.user_id,
                            first_name: formData.nombre,
                            last_name: formData.apellido // sobrescribe id con user_id
                          }} 
                        />

                        {/* <button className="btn btn-primary m-4" onClick={() => setIsModalOpen(true)}>
                            Asistencia de alumnos</button>
                            {isModalOpen && (
                                <AttendanceModal 
                                    show={isModalOpen} 
                                    handleClose={() => setIsModalOpen(false)} 
                                    student={students.find((s) => s.id === selectedStudent)} 
                                />
                            )} */}
                        </div>
                      </Form.Group>

                    </div>
                  </Form>
                </Tab>
          {/* Pestaña Pagos */}
            {userRole === 'admin' && (
              <Tab 
              eventKey="pagos" 
              title={
                <div className="d-flex align-items-center ">
                  Movimientos ({movimientosData.count || 0})
                  {(loading) && (
                    <Spinner animation="border" size="sm" className="ms-2" />
                  )}
                </div>
              }
            >
              {loadingMovimientos ? (
                <div className="text-center my-4">
                  <Spinner animation="border" />
                  <p>Cargando historial de movimientos...</p>
                </div>
              ) : errorMovimientos ? (
                <Alert variant="danger">Error al cargar los movimientos</Alert>
              ) : (
                <>
                  {/* Formulario para nuevo pago */}
                  <Form onSubmit={handleAddPago} 
                    className={`mb-4 p-3 rounded ${theme === "light" ? " bg-light" : "bg-dark"}`}
                                    >
                    <h5 className="mb-4"><strong>Agregar Nuevo Pago</strong></h5>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Fecha</Form.Label>
                          <Form.Control
                            type="date"
                            name="fecha"
                            value={newPago.fecha}
                            onChange={handlePagoChange}
                            required
                            className={` ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          />
                        </Form.Group>
                      </div>
                      
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Método</Form.Label>
                          <Form.Select
                            name="medio_pago"
                            value={newPago.medio_pago}
                            onChange={handlePagoChange}
                            required
                            className={` ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          >
                            {PAYMENT_OPTIONS.map((method) => (
                                <option 
                                  key={method.value} 
                                  value={method.value}
                                >
                                  {method.label}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                      {newPago.medio_pago === 'OTRO' && (
                        <div className="col-md-3">
                          <Form.Group>
                            <Form.Label
                              // className='p-0 m-0'
                            >Método Personalizado</Form.Label>
                            <Form.Control
                              className={`p-2 my-2 ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              type="text"
                              name="medio_pago_personalizado"
                              value={newPago.medio_pago_personalizado || ''}
                              onChange={handlePagoChange}
                              required
                            />
                          </Form.Group>
                        </div>
                      )}
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Monto</Form.Label>
                          <Form.Control
                            className={`p-2 my-2 ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            type="number"
                            step="0.01"
                            name="cantidad"
                            value={newPago.cantidad}
                            onChange={handlePagoChange}
                            required
                          />
                        </Form.Group>
                      </div>
                      
                      <div className="col-md-3 d-flex align-items-end">
                        <Button 
                          type="submit" 
                          variant="primary"
                          disabled={loading}
                          className="w-25 p-2"
                        >
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                           
                            <Save size={20} className="" />
                          )}
                        </Button>
                      </div>
                    </div>
                    
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <Form.Group>
                          <Form.Label>Observaciones</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="observaciones"
                            value={newPago.observaciones}
                            onChange={handlePagoChange}
                            className={` ${theme === "light" ? "" : "input-theme-black"}`}
                            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Form>
                  
                  {/* Tabla de movimientos (pagos + reembolsos) */}
                  <Table striped bordered hover responsive 
                      className={`mt-3 ${theme === "light" ? "" : "table-dark"}`}
                      data-bs-theme={`${theme === "light" ? "light" : "dark"}`}>
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Fecha</th>
                        <th>Método</th>
                        <th>Monto</th>
                        <th>Comprobante</th>
                        <th>Detalles</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {movimientosData.results?.map(movimiento => (
                        <tr 
                          key={movimiento.id} 
                          className={movimiento.tipo_movimiento === 'reembolso' ? 'table-warning' : ''}
                        >
                          <td>
                            {movimiento.tipo_movimiento === 'pago' ? (
                              <Badge bg="success">Pago</Badge>
                            ) : (
                              <Badge bg="warning" text="dark">Reembolso</Badge>
                            )}
                          </td>
                          <td>
                            {editingMovimientoId === movimiento.id ? (
                              <Form.Control
                                type="date"
                                name="fecha"
                                value={editingMovimientoData.fecha}
                                onChange={handleEditingMovimientoChange}
                              />
                            ) : (
                              // new Date(movimiento.fecha).toLocaleDateString('es-ES')
                              dayjs(movimiento.fecha).utc().format('DD/MM/YYYY')
                            )}
                          </td>
                          <td>
                            {editingMovimientoId === movimiento.id ? (
                              movimiento.tipo_movimiento === 'pago' ? (
                                <Form.Select
                                  name="medio_pago"
                                  value={editingMovimientoData.medio_pago}
                                  onChange={handleEditingMovimientoChange}
                                >
                                  {PAYMENT_OPTIONS.map((method) => (
                                <option 
                                  key={method.value} 
                                  value={method.value}
                                >
                                  {method.label}
                                </option>
                              ))}
                                </Form.Select>
                              ) : (
                                <Form.Select
                                  name="medio_reembolso"
                                  value={editingMovimientoData.medio_reembolso}
                                  onChange={handleEditingMovimientoChange}
                                >
                                  {PAYMENT_OPTIONS.map((method) => (
                                <option 
                                  key={method.value} 
                                  value={method.value}
                                >
                                  {method.label}
                                </option>
                              ))}
                                </Form.Select>
                              )
                            ) : (
                              movimiento.tipo_movimiento === 'pago' 
                                ? movimiento.medio_pago_completo 
                                : movimiento.medio_reembolso_completo
                            )}
                          </td>
                          <td>
                            {editingMovimientoId === movimiento.id ? (
                              <Form.Control
                                type="number"
                                step="1"
                                name="cantidad"
                                value={editingMovimientoData.cantidad}
                                onChange={handleEditingMovimientoChange}
                              />
                            ) : (
                              <span className={movimiento.tipo_movimiento === 'pago' ? 'text-success' : 'text-danger'}>
                                {movimiento.tipo_movimiento === 'pago' ? '+' : '-'}
                                {parseFloat(movimiento.cantidad).toFixed(2)} USD
                              </span>
                            )}
                          </td>
                          <td>
                            {movimiento.comprobante ? (
                              <Button 
                                variant="link"
                                size="sm"
                                onClick={() => window.open(movimiento.comprobante, '_blank')}
                              >
                                <Download size={16} className="me-1" />
                                Ver
                              </Button>
                            ) : 'N/A'}
                          </td>
                          <td>
                            {editingMovimientoId === movimiento.id ? (
                              movimiento.tipo_movimiento === 'pago' ? (
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  name="observaciones"
                                  value={editingMovimientoData.observaciones}
                                  onChange={handleEditingMovimientoChange}
                                />
                              ) : (
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  name="motivo"
                                  value={editingMovimientoData.motivo}
                                  onChange={handleEditingMovimientoChange}
                                />
                              )
                            ) : (
                              movimiento.tipo_movimiento === 'pago' 
                                ? (movimiento.observaciones || '-') 
                                : (movimiento.motivo || '-')
                            )}
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              {editingMovimientoId === movimiento.id ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => handleSaveMovimiento(movimiento.id, movimiento.tipo_movimiento)}
                                    disabled={isUpdatingMovimiento || loading}
                                  >
                                    {isUpdatingMovimiento ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : (
                                      'Guardar'
                                    )}
                                  </Button>
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={handleCancelEditMovimiento}
                                    disabled={loading}
                                  >
                                    Cancelar
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => handleEditMovimiento(movimiento)}
                                    title="Editar"
                                    disabled={loading}
                                  >
                                    <Pencil size={14} />
                                  </Button>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleDeleteMovimiento(movimiento.id, movimiento.tipo_movimiento)}
                                    disabled={loading}
                                    title="Eliminar"
                                  >
                                   <Trash2 size={14} />
                                  </Button>
                                  {movimiento.tipo_movimiento === 'pago' && (
                                    <Button
                                      variant="outline-warning"
                                      size="sm"
                                      onClick={() => handleAddReembolso(movimiento)}
                                      title="Agregar reembolso"
                                      disabled={loading}
                                    >
                                      <ArrowLeft size={14} />
                                    </Button>
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
            
                    {/* Paginación */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        disabled={currentPage === 1 || loadingPagos}
                      >
                        Anterior
                      </Button>
                      
                      <span className="text-muted">
                        Página {currentPage} de {Math.ceil(pagosData.count / pageSize)}
                      </span>
                      
                      <Button
                        variant="outline-primary"
                        onClick={() => setCurrentPage(p => p + 1)}
                        disabled={!pagosData.next || loadingPagos}
                      >
                        Siguiente
                      </Button>
                    </div>
                    {/* Modal para agregar reembolso */}
                    <Modal show={showReembolsoModal}
                      onHide={() => setShowReembolsoModal(false)}
                      className={`${theme === 'dark' ? 'modal-dark' : 'modal-light'} custom-modal`}>
                      <Modal.Header closeButton 
                      className={` ${theme === "light" ? "" : "bg-dark text-white"}`}
                      >
                        <Modal.Title>Agregar Reembolso</Modal.Title>
                      </Modal.Header>
                      <Modal.Body
                      className={` ${theme === "light" ? "" : "bg-dark text-white"}`}>
                        {selectedPago && (
                          <Alert variant="info" className="mb-3">
                            <strong>Pago relacionado:</strong> {new Date(selectedPago.fecha).toLocaleDateString()} - {selectedPago.medio_pago_completo}<br />
                            <strong>Monto original:</strong> ${parseFloat(selectedPago.cantidad).toFixed(2)}<br />
                            {/* <strong>Saldo disponible:</strong> ${parseFloat(selectedPago.saldo_restante).toFixed(2)} */}
                          </Alert>
                        )}
                        <Form onSubmit={handleAddReembolsoSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label>Fecha</Form.Label>
                            <Form.Control
                              type="date"
                              name="fecha"
                              value={newReembolso.fecha}
                              onChange={handleReembolsoChange}
                              required
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                          </Form.Group>
                          
                          <Form.Group className="mb-3">
                            <Form.Label>Método de Reembolso</Form.Label>
                            <Form.Select
                              name="medio_reembolso"
                              value={newReembolso.medio_reembolso}
                              onChange={handleReembolsoChange}
                              required
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}

                            >
                              {PAYMENT_OPTIONS.map((method) => (
                                <option 
                                  key={method.value} 
                                  value={method.value}
                                >
                                  {method.label}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          
                          {newReembolso.medio_reembolso === 'OTRO' && (
                            <Form.Group className="mb-3">
                              <Form.Label>Detalle del método</Form.Label>
                              <Form.Control
                                type="text"
                                name="medio_reembolso_personalizado"
                                value={newReembolso.medio_reembolso_personalizado}
                                onChange={handleReembolsoChange}
                                required
                                className={` ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              />
                            </Form.Group>
                          )}
                          
                          <Form.Group className="mb-3">
                            <Form.Label>Monto (USD)</Form.Label>
                            <Form.Control
                              type="number"
                              step="1"
                              min="1"
                              max={selectedPago ? selectedPago.saldo_restante : 0}
                              name="cantidad"
                              value={newReembolso.cantidad}
                              onChange={handleReembolsoChange}
                              required
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                          </Form.Group>
                          
                          <Form.Group className="mb-3">
                            <Form.Label>Motivo</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="motivo"
                              value={newReembolso.motivo}
                              onChange={handleReembolsoChange}
                              required
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                          </Form.Group>
                          
                          <Form.Group className="mb-3">
                            <Form.Label>Comprobante (opcional)</Form.Label>
                            <Form.Control
                              type="file"
                              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                              onChange={(e) => setNewReembolso({
                                ...newReembolso, 
                                comprobante: e.target.files[0]
                              })}
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                          </Form.Group>
                          
                          <div className="d-flex justify-content-end">
                            <Button variant="secondary" onClick={() => setShowReembolsoModal(false)} className="me-2">
                              Cancelar
                            </Button>
                            <Button 
                              variant="primary" 
                              type="submit"
                              disabled={createReembolsoMutation.isLoading || loading}
                            >
                              {createReembolsoMutation.isLoading || loading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                'Crear Reembolso'
                              )}
                            </Button>
                          </div>
                        </Form>
                      </Modal.Body>
                    </Modal>
                  </>
                )}
              </Tab>
              )}
              <Tab 
                eventKey="observaciones" 
                title={
                  <div className="d-flex align-items-center">
                    Observaciones ({observacionesData.count || 0})
                    {(loadingObservaciones || 
                      createObservacionMutation.isLoading || 
                      updateObservacionMutation.isLoading || 
                      deleteObservacionMutation.isLoading) && (
                      <Spinner animation="border" size="sm" className="ms-2" />
                    )}
                  </div>
                }
              >
                {loadingObservaciones ? (
                  <div className="text-center my-4">
                    <Spinner animation="border" />
                    <p>Cargando observaciones...</p>
                  </div>
                ) : errorObservaciones ? (
                  <Alert variant="danger">Error al cargar las observaciones</Alert>
                ) : (
                  <>
                    {/* Formulario para nueva observación */}
                    <Form onSubmit={handleAddObservacion}                  
                          className={`mb-4 p-3 bg-light rounded ${theme === "light" ? "bg-light" : "bg-dark"}`}>
                      <h5 className="mb-4"><strong>Agregar Nueva Observación</strong></h5>
                      
                      <div className="row g-3">
                        <div className="col-md-12">
                          <Form.Group>
                            <Form.Label>Contenido</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="contenido"
                              value={newObservacion.contenido}
                              onChange={(e) => {
                                if (e.target.value.length <= 1000) {
                                  handleObservacionChange(e);
                                }
                              }}
                              required
                              className={` ${theme === "light" ? "" : "input-theme-black"}`}
                              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                            <Form.Text className="text-muted">
                              {newObservacion.contenido.length}/1000 caracteres
                            </Form.Text>
                          </Form.Group>
                        </div>
                        <div className={`d-flex flex-row justify-content-between`}>
                          {userRole === 'admin' && (<div className="col-md-6 m-3">
                            <Form.Group>
                              <Form.Label>Visibilidad</Form.Label>
                              <Form.Select
                                name="visibilidad"
                                value={newObservacion.visibilidad}
                                onChange={handleObservacionChange}
                                required
                                className={` ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              >
                                <option value="ADMIN">Solo administradores</option>
                                <option value="SUPERVISION">Supervisión</option>
                                {/* <option value="PUBLICA">Todos los usuarios con acceso</option> */}
                              </Form.Select>
                            </Form.Group>
                          </div>)}
                          
                          <div className="col-md-6 d-flex align-items-end">
                            <Button 
                              type="submit" 
                              variant="primary"
                              disabled={createObservacionMutation.isLoading}
                            >
                              {createObservacionMutation.isLoading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                'Agregar'
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>

                    {/* Tabla de observaciones existentes */}
                    <Table striped bordered hover responsive className={`p-3 ${theme === "light" ? "" : "table-dark"}`}>
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Creado por</th>
                          <th className='w-50'>Contenido</th>
                          <th>Visibilidad</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {observacionesData.results
                          ?.filter(observacion => {
                            if (userRole === 'admin') return true;
                            // Solo mostrar observaciones de supervisión si el rol es supervisión
                            return observacion.visibilidad === 'SUPERVISION';
                          })
                          .map(observacion => (
                          <tr key={observacion.id}>
                            <td>
                              {dayjs(observacion.creado).format('DD/MM/YYYY HH:mm')}
                            </td>
                            <td>
                              {observacion.creado_por_nombre || 'Usuario desconocido'}
                            </td>
                            <td style={{overflowWrap: 'break-word'}}>
                              {editingObservacionId === observacion.id ? (
                                <div>
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="contenido"
                                    value={editingObservacionData.contenido}
                                    onChange={(e) => {
                                      if (e.target.value.length <= 1000) {
                                        handleObservacionChange(e);
                                      }
                                    }}
                                    required
                                  />
                                  <Form.Text className="text-muted">
                                    {newObservacion.contenido.length}/1000 caracteres
                                  </Form.Text>    
                                </div>                              
                              ) : (
                                observacion.contenido
                              )}
                            </td>
                            <td>
                              {editingObservacionId === observacion.id ? (
                                <Form.Select
                                  name="visibilidad"
                                  value={editingObservacionData.visibilidad}
                                  onChange={handleEditingObservacionChange}
                                >
                                  <option value="ADMIN">Solo administradores</option>
                                  <option value="SUPERVISION">Supervisión</option>
                                  <option value="PUBLICA">Todos los usuarios con acceso</option>
                                </Form.Select>
                              ) : (
                                <Badge bg={getBadgeColor(observacion.visibilidad)}>
                                  {observacion.visibilidad}
                                </Badge>
                              )}
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                {editingObservacionId === observacion.id ? (
                                  <>
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={handleSaveObservacion}
                                      disabled={updateObservacionMutation.isLoading}
                                    >
                                      {updateObservacionMutation.isLoading ? (
                                        <Spinner animation="border" size="sm" />
                                      ) : (
                                        'Guardar'
                                      )}
                                    </Button>
                                    <Button
                                      variant="secondary"
                                      size="sm"
                                      onClick={handleCancelEditObservacion}
                                    >
                                      Cancelar
                                    </Button>
                                  </>
                                ) : canEditObservacion(observacion) ? (
                                   (
                                    <>
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => handleEditObservacion(observacion)}
                                        title="Editar"
                                      >
                                        <Edit size={16} className="me-1" />
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleDeleteObservacion(observacion.id)}
                                        disabled={deleteObservacionMutation.isLoading}
                                        title="Eliminar"
                                      >
                                        {deleteObservacionMutation.isLoading ? (
                                          <Spinner animation="border" size="sm" />
                                        ) : (
                                          <Trash2 size={16} className="me-1" />
                                        )}
                                      </Button>
                                    </>
                                  )
                                ) : <p className="text-muted ">Sin acciones</p>}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    {/* Paginación */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={() => setCurrentPageObservaciones(p => Math.max(1, p - 1))}
                        disabled={currentPageObservaciones === 1 || loadingObservaciones}
                      >
                        Anterior
                      </Button>
                      <span className="text-muted">
                        Página {currentPageObservaciones} de {Math.ceil(observacionesData.count / pageSize)}
                      </span>
                      <Button
                        variant="outline-primary"
                        onClick={() => setCurrentPageObservaciones(p => p + 1)}
                        disabled={!observacionesData.next || loadingObservaciones}
                      >
                        Siguiente
                      </Button>
                    </div>
                    </>
                    )}
                    </Tab>
                    <Tab
                      eventKey="periodos"
                      title={
                        <div className="d-flex align-items-center">
                          Periodos ({periodosData.count || 0})
                          {(loadingPeriodos ||
                            createPeriodo.isLoading ||
                            updatePeriodo.isLoading ||
                            deletePeriodo.isLoading) && (
                            <Spinner animation="border" size="sm" className="ms-2" />
                          )}
                        </div>
                      }
                    >
                      {/* Botón para crear nuevo periodo */}
                      <Form
                          className={`mb-4 p-3 bg-light rounded ${theme === "light" ? "bg-light" : "bg-dark"}`}
                        onSubmit={e => {
                          e.preventDefault();
                          if (!e.target.inicio.value || !e.target.fin.value) {
                            toast.error("Debes ingresar ambas fechas");
                            return;
                          }
                          createPeriodo({
                            inicio_acceso: e.target.inicio.value,
                            expiracion: e.target.fin.value,
                            alumno: alumno.id,
                            observaciones: e.target.observaciones.value || '',
                          });
                          e.target.reset();
                        }}
                      >
                        <div className="row g-3 align-items-end" style={{ display: userRole === 'admin' ? '' : 'none' }}>
                          <div className="col-md-3">
                            <Form.Group>
                              <Form.Label>Fecha Inicio</Form.Label>
                              <Form.Control
                                type="date"
                                name="inicio"
                                required
                                className={` ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-3">
                            <Form.Group>
                              <Form.Label>Fecha Fin</Form.Label>
                              <Form.Control
                                type="date"
                                name="fin"
                                required
                                className={` ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-3">
                            <Form.Group>
                              <Form.Label>Observaciones</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={1}
                                name="observaciones"
                                placeholder="Opcional"
                                className={` ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                                maxLength={1000}
                                disabled={loading}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-2">
                            <Button
                              type="submit"
                              variant="primary"
                              disabled={createPeriodo.isLoading || loading}
                              className="w-100"
                            >
                              {createPeriodo.isLoading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "Crear Periodo"
                              )}
                            </Button>
                          </div>
                        </div>
                      </Form>
                      <div>
                        {loadingPeriodos ? (
                          <Spinner animation="border" />
                        ) : errorPeriodos ? (
                          <Alert variant="danger">Error cargando periodos</Alert>
                        ) : (
                          <Table striped bordered hover responsive
                          
                      className={`w-75 m-auto ${theme === "light" ? "" : "table-dark"}`}
                      data-bs-theme={`${theme === "light" ? "light" : "dark"}`}>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Fecha Inicio</th>
                                <th>Fecha Fin</th>
                                <th>Fecha Suspendido Skool</th>
                                <th>Meses</th>
                                <th>Observaciones</th>
                                <th className=''>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {periodosData.results.map((periodo, idx) => {
                                // Busca si este periodo está en edición en el estado local
                                const periodoEdit = periodosEditState.find(p => p.id === periodo.id) || {};
                                const isEditing = periodoEdit.isEditing || false;
                                return (
                                  <tr key={periodo.id}>
                                  <td>{idx + 1 + (currentPagePeriodos - 1) * pageSize}</td>
                                  <td>
                                    {isEditing ? (
                                    <Form.Control
                                      type="date"
                                      value={periodoEdit.editInicio || periodo.inicio_acceso}
                                      onChange={e => {
                                      const value = e.target.value;
                                      setPeriodosEditState(prev =>
                                        prev.map(p =>
                                        p.id === periodo.id
                                          ? { ...p, editInicio: value }
                                          : p
                                        )
                                      );
                                      }}
                                    />
                                    ) : (
                                    dayjs(periodo.inicio_acceso).format('DD/MM/YYYY') || 'N/A'
                                    )}
                                  </td>
                                  <td>
                                    {isEditing ? (
                                    <Form.Control
                                      type="date"
                                      value={periodoEdit.editFin || periodo.expiracion}
                                      onChange={e => {
                                      const value = e.target.value;
                                      setPeriodosEditState(prev =>
                                        prev.map(p =>
                                        p.id === periodo.id
                                          ? { ...p, editFin: value }
                                          : p
                                        )
                                      );
                                      }}
                                    />
                                    ) : (

                                    dayjs(periodo.expiracion).format('DD/MM/YYYY') || 'N/A'
                                    
                                    )}
                                  </td>
                                  <td>
                                  {isEditing ? (
                                    <Form.Control
                                      type="date"
                                      value={periodoEdit.editSuspension || periodo.fecha_suspension}
                                      onChange={e => {
                                      const value = e.target.value;
                                      setPeriodosEditState(prev =>
                                        prev.map(p =>
                                        p.id === periodo.id
                                          ? { ...p, editSuspension: value }
                                          : p
                                        )
                                      );
                                      }}
                                    />
                                    ) : periodo.fecha_suspension ? (

                                    dayjs(periodo.fecha_suspension).format('DD/MM/YYYY') || 'N/A'
                                    
                                    ): ''}
                                  </td>
                                  <td>
                                    {periodo.meses_duracion || 'N/A'}
                                  </td>
                                  <td>
                                    {isEditing ? (
                                    <Form.Control
                                      as="textarea"
                                      rows={3}
                                      value={periodoEdit.observaciones || ''}
                                      onChange={e => {
                                      const value = e.target.value;
                                      setPeriodosEditState(prev =>
                                        prev.map(p =>
                                        p.id === periodo.id
                                          ? { ...p, observaciones: value }
                                          : p
                                        )
                                      );
                                      }}
                                    />
                                    ) : (
                                    periodo.observaciones || ''
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2 justify-content-center">
                                    {isEditing ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                        updatePeriodo({
                                          id: periodo.id,
                                          updatedData: {
                                          inicio_acceso: periodoEdit.editInicio || periodo.inicio_acceso,
                                          expiracion: periodoEdit.editFin || periodo.expiracion,
                                          observaciones: periodoEdit.observaciones || periodo.observaciones,
                                          fecha_suspension: periodoEdit.editSuspension || periodo.fecha_suspension,
                                          },
                                        });
                                        setPeriodosEditState(prev =>
                                          prev.map(p =>
                                          p.id === periodo.id
                                            ? { ...p, isEditing: false }
                                            : p
                                          )
                                        );
                                        }}
                                        className="me-2"
                                      >
                                        Guardar
                                      </Button>
                                      <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => {
                                        setPeriodosEditState(prev =>
                                          prev.map(p =>
                                          p.id === periodo.id
                                            ? { ...p, isEditing: false, editInicio: undefined, editFin: undefined }
                                            : p
                                          )
                                        );
                                        }}
                                      >
                                        Cancelar
                                      </Button>
                                      </>
                                    ) : (
                                      <>
                                      <Button
                                        variant="outline-warning"
                                        size="sm"
                                        onClick={() => {
                                        setPeriodosEditState(prev => {
                                          // Si ya existe, solo cambia isEditing, si no, agrega uno nuevo
                                          const exists = prev.some(p => p.id === periodo.id);
                                          if (exists) {
                                          return prev.map(p =>
                                            p.id === periodo.id
                                            ? { ...p, isEditing: true, editInicio: p.inicio_acceso, editFin: p.expiracion }
                                            : p
                                          );
                                          } else {
                                          return [
                                            ...prev,
                                            {
                                            id: periodo.id,
                                            isEditing: true,
                                            editInicio: periodo.inicio_acceso,
                                            editFin: periodo.expiracion
                                            }
                                          ];
                                          }
                                        });
                                        }}
                                        title='Editar periodo'
                                        disabled={loading}
                                        className='w-25 mx-3'
                                      >
                                        <Pencil size={14} />
                                      </Button>
                                      {/* Confirmación para eliminar periodo */}
                                      <ConfirmDialog
                                        open={periodoEdit.confirmDelete || false}
                                        title="Confirmar eliminación"
                                        message={`¿Estás seguro que deseas eliminar el periodo del ${dayjs(periodo.inicio_acceso).format('DD/MM/YYYY')} al ${dayjs(periodo.expiracion).format('DD/MM/YYYY')}? Esta acción no se puede deshacer.`}
                                        onConfirm={() => {
                                        deletePeriodo(periodo.id);
                                        setPeriodosEditState(prev =>
                                          prev.map(p =>
                                          p.id === periodo.id
                                            ? { ...p, confirmDelete: false }
                                            : p
                                          )
                                        );
                                        }}
                                        onCancel={() => {
                                        setPeriodosEditState(prev =>
                                          prev.map(p =>
                                          p.id === periodo.id
                                            ? { ...p, confirmDelete: false }
                                            : p
                                          )
                                        );
                                        }}
                                      />
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => {
                                        setPeriodosEditState(prev => {
                                          const exists = prev.some(p => p.id === periodo.id);
                                          if (exists) {
                                          return prev.map(p =>
                                            p.id === periodo.id
                                            ? { ...p, confirmDelete: true }
                                            : p
                                          );
                                          } else {
                                          return [
                                            ...prev,
                                            { id: periodo.id, confirmDelete: true }
                                          ];
                                          }
                                        });
                                        }}
                                        className="ms-2 w-25 m-auto"
                                        title='Eliminar periodo'
                                        disabled={loading}
                                      >
                                        <Trash2 size={14} />
                                      </Button>
                                    </>
                                    )}
                                    </div>
                                    
                                  </td>
                                  </tr>

                                );
                              })}
                                  {/* Totalizador de meses */}
                                  { (
                                      <tr>
                                        <td colSpan={4} className="text-end fw-bold">
                                          Total meses:
                                        </td>
                                        <td className="fw-bold">
                                          {periodosData.results.reduce(
                                            (acc, p) => acc + (parseFloat(p.meses_duracion) || 0),
                                            0
                                          )}
                                        </td>
                                        <td colSpan={2}></td>
                                      </tr>
                                    )}
                            </tbody>
                          </Table>
                        )}
                      </div>
                      {/* 
                        Calcula el número total de páginas para la paginación de periodos
                      */}
              {(() => {
                const pageCount = Math.ceil((periodosData.count || 0) / pageSize);
                return (
                  <Pagination 
                    className="justify-content-center mt-4"
                    style={{ visibility: pageCount > 1 ? 'visible' : 'hidden' }
                  }
                  >
                    <Pagination.Prev 
                      onClick={() => setCurrentPagePeriodos(old => Math.max(old - 1, 1))}
                      disabled={currentPagePeriodos === 1}
                    />
                    
                    {[...Array(pageCount).keys()].map(page => (
                      <Pagination.Item
                        key={page + 1}
                        active={page + 1 === currentPagePeriodos}
                        onClick={() => setCurrentPagePeriodos(page + 1)}
                      >
                        {page + 1}
                      </Pagination.Item>
                    ))}
                    
                    <Pagination.Next 
                      onClick={() => setCurrentPagePeriodos(old => Math.min(old + 1, pageCount))}
                      disabled={currentPagePeriodos === pageCount || pageCount === 0}
                    />
                  </Pagination>
                );
              })()}
              </Tab>
            </Tabs>
          </Modal.Body>

      <Modal.Footer
        className={`large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark  '}`}>
        <div className="d-flex flex-row w-75 justify-content-center m-auto">
          {isEditing ? (
            <>
              {mode === 'edit' ? (
                <Button 
                  variant="secondary" 
                  onClick={() => setIsEditing(false)}
                  disabled={loading}
                >
                  <X size={16} className="me-1" /> Cancelar
                </Button>
              ) : (
                <Button 
                  variant="secondary" 
                  onClick={onClose}
                  disabled={loading}>
                  Cerrar
                </Button>
              )}
              <Button 
                variant="primary" 
                type="submit" 
                form="editForm"
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" className="me-1" />
                ) : (
                  <Save size={16} className="me-1" />
                )}
                Guardar
              </Button>
            </>
          ) : (
            <>
              <Button variant="secondary" onClick={onClose}>
                Cerrar
              </Button>
              {activeTab !== 'pagos' && (
                <>
                <div className="d-flex flex-row w-75">

                  <Button
                    disabled={userRole !== 'admin'}
                    variant="danger" 
                    onClick={() => handleDelete(alumno)}
                    className="mx-2"

                    style={{ visibility: userRole === 'admin' ? 'block' : 'hidden' }}
                  > 
                    <Trash2 size={16} className="me-1" /> Eliminar
                  </Button>
                  <Button 
                    type="button"
                    variant="primary" 
                    onClick={(e) => {
                        e.preventDefault(); 
                        setIsEditing(true);
                      }}>
                    <Edit size={16} className="me-1" /> Editar
                  </Button>
                </div>
                
                </>
              )}
              
            </>
          )}
        </div>
      </Modal.Footer>
    </Modal>
    <ConfirmDialog
      open={deleteDialog.open}
      title="Confirmar eliminación"
      message={`¿Estás seguro que deseas eliminar al alumno ${deleteDialog.alumnoName}? Esta acción no se puede deshacer.`}
      onConfirm={() => {
        deleteAlumnoMutation.mutate(deleteDialog.alumnoId);
        setDeleteDialog({ open: false, alumnoId: null, alumnoName: '' });
      }}
      onCancel={() => setDeleteDialog({ open: false, alumnoId: null, alumnoName: '' })}
    />
    
    
  </>
  );
};

export default AdminModal;
